import React from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import RefrigerantsWidget from "../../../components/RefrigerantsWidget/RefrigerantsWidget";
import ToolsWidget from "../../../components/ToolsWidget/ToolsWidget";
import Skeleton from "../../../components/Skeleton/Skeleton";
import ContentPanel from "../../../components/ContentPanel/ContentPanel";
import store from "../../../store";
import {Helmet} from "react-helmet";

const lifeSciences = () => (
  <div className="wrapper">
      <Helmet>
          {
              store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                  return row.rowTitle === "Learn" ? row.sections.map((section) => {
                      return section.title === "Specialty Shipments" ? section.subsections.map((subsection) => {
                                  return subsection.title === "Life Sciences" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                              })
                              : null
                  }) : null
              }) : null
          }
      </Helmet>
    <Breadcrumbs/>

    <ContentPanel
      skeleton={<Skeleton type="MAIN_PANEL"/>}
      errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
      templateUrl="./content/learn/page-components/text-block/life-sciences-heading.html"
    />

    <ContentPanel
      skeleton={<Skeleton type="MAIN_PANEL"/>}
      errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
      templateUrl="./content/learn/page-components/content-detail/life-sciences-body-1.html"
    />

    <div className="mtl">
      <RefrigerantsWidget pageType="Life Sciences" />
    </div>

    <div className="mb36">
      <ToolsWidget/>
    </div>

  </div>
);

export default lifeSciences;



// WEBPACK FOOTER //
// ./src/pages/learn/specialty-shipments/LifeSciences.js